// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sRBV","textarea":"styles_textarea__1eyB5"};